module.exports = "https://preprod.web-phone.apps.phone.com/static/media/dtmf-0.a51ab2f3.mp3";